import CustomerForm from '../createCustomer/customerForm';

const Information = ({
	setCustomerData,
	setPrescriptionsDocsList,
	prescriptionsDocsList,
	customerData,
	cityList,
	customerDocs,
	setCustomerDocs,
	errors,
	setError,
	isEdit,
	totalOutStandingAmount,
	amountDueFifteenDays,
}) => {
	return (
		<div className="max-w-1297">
			<div style={{ padding: '1rem 2rem 0' }}>
				<div
					style={{
						borderBottom: '1px solid #EEEFF3',
						height: '75px',
						width: '100%',
						gap: '10px',
					}}
					className="d-flex"
				>
					<div
						style={{ width: '25%', height: '68px', marginTop: '-12px' }}
						className="d-flex flex-column"
					>
						<div>
							<h4
								className="fw-bold"
								style={{ fontSize: '16px' }}
							>
								Summary
							</h4>
						</div>
						<div>
							<p style={{ fontSize: '1.5rem', color: '#555B67' }}>Total Outstanding Receivables</p>
						</div>
						<div>
							<h4
								className="fw-bold"
								style={{ fontSize: '16px' }}
							>
								{`₹ ${Number(totalOutStandingAmount).toFixed(2)}`}
							</h4>
						</div>
					</div>

					<div
						style={{
							height: '55px',
							width: '65%',
							marginTop: '10px',
							borderLeft: '1px solid #EEEFF3',
							paddingLeft: '55px',
						}}
						className="d-flex flex-column "
					>
						<div>
							<p style={{ fontSize: '1.5rem', color: '#555B67' }}>Due In Next 15Days</p>
						</div>
						<div>
							<h4
								className="fw-bold"
								style={{ fontSize: '16px' }}
							>
								{`₹ ${amountDueFifteenDays}`}
							</h4>
						</div>
					</div>
				</div>
				{/* Summary End */}

				{/* <div
					className="d-flex"
					style={{ gap: '10px', padding: '10px 0px 10px 0px ', fontSize: '1.5rem' }}
				>
					<b style={{ borderBottom: '2px solid #3B58FF', height: '24px' }}>Information</b>
					<p>Referrals</p>
				</div> */}
			</div>
			<CustomerForm
				setCustomerData={setCustomerData}
				setPrescriptionsDocsList={setPrescriptionsDocsList}
				prescriptionsDocsList={prescriptionsDocsList}
				customerData={customerData}
				cityList={cityList}
				customerDocs={customerDocs}
				setCustomerDocs={setCustomerDocs}
				errors={errors}
				setError={setError}
				isEdit={isEdit}
			/>
		</div>
	);
};
export default Information;
